import { pmFetchJson } from "@penmate/react-shared/api/pmFetch";

export type DynamicPricingOffer = {
  service_key: string | null;
  archetype: string | null;
  price_cents: number | null;
  bonus_credits: number | null;
  discount_cents: number | null;
  expires_at: string | null;
  redemption_id: string | null;
  bundle_size: number | null;
  bundle_price_cents: number | null;
  meta?: any;
};

export type LetterOffersResponse = {
  user_id?: number;
  enrolled?: boolean;
  display_mode?: string;
  displayed_bundle_sizes?: number[];
  target_bundle_size?: number;
  displayed_offers?: DynamicPricingOffer[];
  recommended_offer?: DynamicPricingOffer | null;
  offers?: any;
  [k: string]: unknown;
};

export async function fetchLetterOffers(args: { letterId: string }): Promise<LetterOffersResponse> {
  return pmFetchJson<LetterOffersResponse>(
    `/letters/${encodeURIComponent(args.letterId)}/offers`,
    { method: "GET" },
  );
}

